import useSWR from "swr";
import type { PartyView } from "@/lib/core/schemas/party-view";

const fetcher = async (url: string) => {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error("Failed to fetch party data");
  }
  return res.json();
};

export function useParty(campaignId: string | null) {
  const { data, error, isLoading, mutate } = useSWR<PartyView>(
    campaignId ? `/api/campaigns/${campaignId}/party` : null,
    fetcher
  );

  return { party: data, isLoading, error, mutate };
}
